import React from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { selectCurrentLanguage } from '../../../redux/selectors';

import { closeModal } from '../../../redux/actions/modalActions';

import styles from './Modal.module.css'

interface AccessibilityOption {
    type: string;
    text: Record<string, string>;
    attribute: string;
}

const accessibilityOptions: AccessibilityOption[] = [
    {
        type: 'signLanguage',
        text: {
            he: 'סרטון בשפת הסימנים',
            en: 'Sign Language video'
        },
        attribute: 'accessibility_hearing_video_sign_language'
    },
    {
        type: 'subtitle',
        text: {
            he: 'סרטון כתוביות',
            en: 'Subtitle video'
        },
        attribute: 'accessibility_hearing_video_subtitles'
    }
]

interface AccessibilityModalProps {
    setAsset: (attribute: string) => void;
}

const AccessibilityModal: React.FC<AccessibilityModalProps> = ({setAsset}) => {

    const currentLanguage = useAppSelector(selectCurrentLanguage);

    return (
        <div className={styles['modal-menu']}>
            <ul>
                {
                    accessibilityOptions.map(option => {
                        return (<li key={option.type} onClick={() => {
                            setAsset(option.attribute)
                            
                            }}>
                            {option.text[(currentLanguage ?? 'en').split('-')[0]]}
                        </li>)
                    })
                }
            </ul>
        </div>
    );
};

export default AccessibilityModal;
